import PropTypes from 'prop-types';
import ContactTableRows from 'apps/contact/components/contacts/contact-table-rows';
import Decorator from 'clientDecorator';
import { getRemoteIdBackgroundColor, parseEmailQuery, phoneMatch } from '../config/query-highlight-utilities';
import ContactDataList from 'apps/layout/global-search/components/contact-data-list';

const SimpleContactsTable = ({ contacts = [], queryType = 'all', query = '' }) => {
  const isColumnEmphasized = (columnType) => {
    const mapping = {
      name: 'constituent',
      email: 'emails_highlight',
      phone: 'phones_highlight',
      remoteId: 'remote_id_highlight',
    };

    return queryType && mapping[queryType] === columnType;
  };

  const ContactTableRowsCopy = {
    ...ContactTableRows,
    phones_highlight: {
      label: 'phones_highlight',
      width: 200,
      row: (data) => (
        <ContactDataList
          items={data?.phones || []}
          getValue={(phone) => phone.phone?.value}
          isMatched={(phone) => phoneMatch(phone.phone?.value, query)}
        />
      ),
    },
    emails_highlight: {
      label: 'emails_highlight',
      width: 300,
      row: (data) => {
        return (
          <ContactDataList
            items={data?.emails || []}
            getValue={(email) => email.email?.value}
            isMatched={(email) =>
              parseEmailQuery(query).some((part) => email.email?.value?.toLowerCase().includes(part))
            }
          />
        );
      },
    },
    remote_id_highlight: {
      label: 'remote_id_highlight',
      width: 200,
      row: (data) => {
        let remote_id = [];
        if (Array.isArray(data?.identities)) {
          remote_id = (data?.identities || []).find((identity) => identity.type === 'remote_id')?.value;
        }
        return (
          <span
            aria-label={`Remote ID, ${remote_id}`}
            className="fs-exclude-data"
            style={getRemoteIdBackgroundColor(remote_id, query, queryType)}
          >
            {remote_id}
          </span>
        );
      },
    },
  };

  return (
    <div className="simple-contacts-table-container" style={{ maxHeight: '700px', overflow: 'auto' }}>
      <table className="simple-contacts-table table">
        <thead className="simple-contacts-table--header">
          <tr>
            <th
              style={{ width: ContactTableRowsCopy.constituent.width }}
              className={isColumnEmphasized('constituent') ? 'emphasized-column-header' : ''}
            >
              Constituent
            </th>
            <th
              style={{ width: ContactTableRowsCopy.emails_highlight.width }}
              className={isColumnEmphasized('emails_highlight') ? 'emphasized-column-header' : ''}
            >
              Email Addresses
            </th>
            <th
              style={{ width: ContactTableRowsCopy.phones_highlight.width }}
              className={isColumnEmphasized('phones_highlight') ? 'emphasized-column-header' : ''}
            >
              Phone Numbers
            </th>
            <th
              style={{ width: ContactTableRowsCopy.remote_id_highlight.width }}
              className={isColumnEmphasized('remote_id_highlight') ? 'emphasized-column-header' : ''}
            >
              Remote ID
            </th>
            <th style={{ width: ContactTableRowsCopy.relationships.width }}>Relationships</th>
            <th style={{ width: ContactTableRowsCopy.lifetime_giving.width }}>Lifetime Giving</th>
            <th style={{ width: ContactTableRowsCopy.assignee.width }}>Assigned To</th>
            <th style={{ width: ContactTableRowsCopy.constituency.width }}>Constituency</th>
          </tr>
        </thead>
        <tbody className="simple-contacts-table--body">
          {contacts.map((contact) => {
            const parsedContact = Decorator.Contacts.parse(contact);
            return (
              <tr key={contact.id}>
                <td
                  className={`${ContactTableRowsCopy.constituent.className} ${
                    isColumnEmphasized('constituent') ? 'emphasized-column' : ''
                  }`}
                >
                  {ContactTableRowsCopy.constituent.row(parsedContact)}
                </td>
                <td className={isColumnEmphasized('emails_highlight') ? 'emphasized-column' : ''}>
                  {ContactTableRowsCopy.emails_highlight.row(parsedContact)}
                </td>
                <td className={isColumnEmphasized('phones_highlight') ? 'emphasized-column' : ''}>
                  {ContactTableRowsCopy.phones_highlight.row(parsedContact)}
                </td>
                <td className={isColumnEmphasized('remote_id_highlight') ? 'emphasized-column' : ''}>
                  {ContactTableRowsCopy.remote_id_highlight.row(parsedContact)}
                </td>
                <td>{ContactTableRowsCopy.relationships.row(parsedContact)}</td>
                <td>{ContactTableRowsCopy.lifetime_giving.row(parsedContact)}</td>
                <td>{ContactTableRowsCopy.assignee.row(parsedContact)}</td>
                <td>{ContactTableRowsCopy.constituency.row(parsedContact)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

SimpleContactsTable.propTypes = {
  contacts: PropTypes.array.isRequired,
  queryType: PropTypes.string,
  query: PropTypes.string,
};

export default SimpleContactsTable;
